module.exports = __webpack_public_path__ + "static/media/portisIcon.b234b2bf.png";